import { useSelector } from 'react-redux'
import _ from 'lodash'
import { featureAvailabilitiesSelector, featureValuesSelector } from '../selectors'
import { useUserInfo } from '../../user'
import { canUserAccessFeature } from '../utils'
import { FeatureName } from '../types'

export function useBetaFeatures() {
  const features = useSelector(featureValuesSelector('userSettings'))
  const availabilities = useSelector(featureAvailabilitiesSelector)
  const { email } = useUserInfo()

  return _.omitBy(
    features,
    (value, name) => !canUserAccessFeature(name as FeatureName, email, availabilities)
  )
}
